import { useState } from 'react';

// Named confirmation before any deletion (PD-08 — deletion must be named, never
// a side effect).
//
// When `requireTyped` is given, the exact string must be typed before the button
// enables. That is reserved for deleting a creator, which destroys someone else's
// work: a misdirected click cannot do it, only a deliberate act can.
export function ConfirmDeleteDialog(input: {
  title: string;
  detail: string;
  requireTyped?: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const [typed, setTyped] = useState('');
  const satisfied = !input.requireTyped || typed.trim().toLowerCase() === input.requireTyped.toLowerCase();

  return (
    <div className="confirmBackdrop" role="dialog" aria-modal="true">
      <div className="confirmPanel">
        <h3>{input.title}</h3>
        <p className="mutedNote">{input.detail}</p>

        {input.requireTyped ? (
          <>
            <p className="confirmPrompt">
              Type <b>{input.requireTyped}</b> to confirm.
            </p>
            <input
              type="text"
              autoComplete="off"
              value={typed}
              onChange={(event) => setTyped(event.target.value)}
              placeholder={input.requireTyped}
            />
          </>
        ) : null}

        <div className="confirmActions">
          <button className="buttonSecondary" type="button" onClick={input.onCancel} disabled={input.busy}>
            Cancel
          </button>
          <button
            className="buttonDanger"
            type="button"
            onClick={input.onConfirm}
            disabled={!satisfied || input.busy}
          >
            {input.busy ? 'Deleting…' : 'Delete permanently'}
          </button>
        </div>
      </div>
    </div>
  );
}
